import React from 'react'

import './assets/css/fonts.css'

import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

import GlobalStyles from './styles/globalStyles'
import Routes from './routes'

const alertOptions = {
  position: 'bottom center',
  timeout: 5000,
  offset: '30px',
  transition: 'scale',
  containerStyle: {
    zIndex: 100
  }
}

function App() {
  return (
    <AlertProvider template={AlertTemplate} {...alertOptions}>
      <div id="App">
        <GlobalStyles/>
        <Routes/>
      </div>
    </AlertProvider>
  );
}

export default App;
